import Loader from 'react-loader-spinner';
export default function Loading() {
    return (
        <div style={{ textAlign: 'center' }}>
            <Loader
                type="Circles"
                color="#00BFFF"
                height={100}
                width={100}
                timeout={3000} //3 secs
            />
        </div>
    );
}
